import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import LottieLoader from './LottieLoader';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const LoadingScreen = props => {
    const classes = useStyles();
    const { open } = props
    return (
        <div>
            {/* <div style={{ opacity: 1, filter: 'blur(10px) brightness(0.9)', position: 'absolute'}} ></div> */}
            <Backdrop className={classes.backdrop} open={open} style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '5px',
                    textAlign: 'center',
                    lineHeight: 1,
                    backdropFilter: 'blur(10px)',
                    webkitBackdropFilter: 'blur(10px)',
                    // padding: '20px 40px'
                    }
                }>
                <LottieLoader stop = {!open} />
            </Backdrop>
        </div>
    );
};

LoadingScreen.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default LoadingScreen;